import React, { useState } from 'react'
import SongPreview from '../SongPreview'

const SongList = ({ songs, onSelect, suggestionListId }) => {
  const [activeId, setActiveId] = useState(null)

  return (
    <>
      { songs.map(song => (
        <SongPreview
          key={song.id}
          id={song.id}
          {...song.attributes}
          onAdd={onSelect}
          provider={song.attributes.provider}
          suggestionListId={song.attributes.suggestionListId || suggestionListId}
          activeId={activeId}
          setActiveId={setActiveId}
        />
      ))}
    </>
  )
}

export default SongList
